import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const promotionsApi = createApi({
  reducerPath: 'promotionsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_CHECKOUT}/order-summary-core/api/v1`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['Promotions'],
  endpoints: (build) => ({
    getPromotion: build.query({
      query: ({ event, code }) => `summary/events/${event}/code/${code}`,
      providesTags: (result, error, id) => [{ type: 'Promotions', id }],
    }),
  }),
});

export const { useGetPromotionQuery, useLazyGetPromotionQuery } = promotionsApi;
